<template>
    <div id="employee" style="height:100%;">
        <el-row>
            <el-col :span="24">
                <el-collapse v-model="activeName" style="margin-bottom:15px;">
                    <el-collapse-item title="操作面板" name="1">
                        <div class="t-op__container">
                            <div class="t-op__item">
                                <el-button type="primary" icon="el-icon-circle-plus" @click="handleAdd">添加</el-button>
                            </div>
                            <div class="t-op__item">
                                <el-input placeholder="请输入员工姓名" v-model="search" class="input-with-select">
                                    <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
                                </el-input>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                        v-loading="loading"
                        :data="tableData"
                        width="100%"
                        :height="tableHeight"
                        stripe>
                    <el-table-column
                            width="70"
                            type="index"
                            label="序号">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="员工姓名"
                            prop="name">
                    </el-table-column>

                    <el-table-column
                            label="登陆名"
                            prop="loginName">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="帐号状态"
                            prop="status"
                            :formatter="fmtStatus">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="所属角色"
                            prop="isAdmin"
                            :formatter="fmtIsAdmin">
                    </el-table-column>
                    <el-table-column
                            label="手机号"
                            prop="mobile">
                    </el-table-column>

                    <!--                    <el-table-column-->
                    <!--                            label="地址"-->
                    <!--                            prop="addr">-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                            label="级别"
                            prop="levelId"
                            :formatter="fmtLevel">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="员工类别"
                            prop="type"
                            :formatter="fmtType">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="微信昵称"
                            prop="nickName">
                    </el-table-column>
                    <el-table-column
                            label="微信头像">
                        <template slot-scope="scope">
                            <img v-if="scope.row.avatar" :src="scope.row.avatar"
                                 style="width:30px;height:30px;border-radius: 30px;"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :hide-on-single-page="value"
                        style="padding:10px 0px;"
                        :page-size="pageSize"
                        :total="total"
                        :current-page="pageIndex"
                        @current-change="onCurrentChange">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="editItem.title" :width="editItem.width" :visible.sync="editItem.visible">
            <el-form :model="editItem.data">
                <el-form-item label="姓名" label-width="150px">
                    <el-input v-model="editItem.data.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="登陆帐号" label-width="150px">
                    <el-input v-model="editItem.data.loginName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" label-width="150px">
                    <el-input v-model="editItem.data.password" show-password autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="帐号状态" label-width="150px">
                    <el-select v-model="editItem.data.status" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.statusList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属角色" label-width="150px">
                    <el-select v-model="editItem.data.isAdmin" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.roleList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="微信openId(意臣)" label-width="150px">
                    <el-input v-model="editItem.data.openId" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="头像地址" label-width="150px">
                    <el-input v-model="editItem.data.avatar" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="150px">
                    <el-input v-model="editItem.data.mobile" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="级别" label-width="150px">
                    <el-select v-model="editItem.data.levelId" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.levelList"
                                :key="item.id"
                                :label="item.level"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="员工类别" label-width="150px">
                    <el-select v-model="editItem.data.type" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.typeList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editItem.visible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        name: "EmployeeManage",
        data() {
            return {
                tableHeight: window.innerHeight * 0.70,
                activeName: ['1'],
                tableData: [],
                search: '',
                value: false,
                pageIndex: 1,
                pageSize: 20,
                total: 0,
                editItem: {
                    width: '60%',
                    visible: false,
                    title: '员工信息',
                    data: {
                        id: 0,
                        levelId: 0,
                        openId: '',
                        name: '',
                        avatar: '',
                        loginName: '',
                        password: '',
                        status: '',
                        isAdmin: false,
                        addr: '',
                        mobile: '',
                        level: '',
                    },

                    isAdd: false,
                    filter: true,
                    levelList: [],
                    roleList: [{text: "管理员", value: true}, {text: "普通员工", value: false}],
                    statusList: [{text: "正常", value: "valid"}, {text: "禁用", value: "invalid"}],
                    typeList: [{text: "内部员工", value: "inner"}, {text: "外包人员", value: "outSource"}]
                },
                loading: false
            }
        },
        methods: {
            fmtStatus(row, column) {
                const item = this.editItem.statusList.find(v => v.value == row.status)
                return item.text
            },
            fmtIsAdmin(row, column) {
                const item = this.editItem.roleList.find(v => v.value == row.isAdmin)
                return item.text
            },
            fmtType(row, column) {
                const item = this.editItem.typeList.find(v => v.value == row.type)
                return item.text
            },
            fmtLevel(row, column) {
                const level = this.editItem.levelList.find(v => v.id == row.levelId)
                if (level) {
                    return level.level
                }
                return ''
            },
            handleAdd() {
                this.editItem.data = {}
                this.editItem.title = '添加员工信息'
                this.editItem.visible = true
                this.editItem.isAdd = true
            },
            handleEdit(index, row) {
                console.log(index, row);
                this.editItem.title = '编辑员工信息'
                this.editItem.visible = true
                this.editItem.data = row;

                this.editItem.isAdd = false
            },
            loadData() {
                this.loading = true
                this.$store.dispatch("employee/getUserWithPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageIndex,
                    nickName: this.search
                }).then(response => {
                    this.loading = false
                    this.tableData = response.data.data
                    this.total = response.data.total
                })
            },
            onCurrentChange(page) {
                this.pageIndex = page
                this.loadData()
            },
            sexFormat(row, column, cellValue) {
                if (cellValue === 0) {
                    return '女'
                } else {
                    return '男'
                }
            },
            saveEmployee() {
                this.$store.dispatch("employee/saveUser", this.buildSubmitData())
                    .then(success => {
                        this.$message({
                            message: success.data.message,
                            type: 'success'
                        });
                        this.editItem.visible = false
                        this.editItem.data = {}
                        this.loadData()
                    })
            },
            createEmployee() {
                this.$store.dispatch("employee/createUser", this.buildSubmitData())
                    .then(success => {
                        this.$message({
                            message: success.data.message,
                            type: 'success'
                        });
                        this.editItem.visible = false
                        this.editItem.data = {}
                        this.loadData()
                    });
            },
            confirm() {
                if (this.editItem.isAdd) {
                    this.createEmployee()
                } else {
                    this.saveEmployee()
                }
            },
            buildSubmitData() {
                return {data: this.editItem.data}
            },
            loadLevelConfigList() {
                this.$store.dispatch("employee/getAllLevelConfig")
                    .then(response => {
                        this.editItem.levelList = response.data.data
                    })
            }
        },
        created() {
            this.loadLevelConfigList()
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// employeeManage.vue?6a8b70cb